import { Outlet, createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";

import { Card } from "@/components/Card/card";
import { HStack } from "@/components/Layout";
import { Loader } from "@/components/Loading";
import { cn } from "@/lib/cn";

import { ItOperationCorePackageSidebar as Sidebar } from "./-components/Sidebar";
import { useItOperationCorePackageSidebar } from "./-components/Sidebar/hooks";
import { listOperationPackages } from "./-query/api";

/**
 * IT Operation Coreのパッケージ一覧を表示するレイアウトコンポーネント。
 * 中身の詳細なパッケージの表示は、`/it-operation-core/packages/$packageId`で行う。
 */
export const Route = createFileRoute(
  "/_staff/it-operation-core/_root/packages",
)({
  loader: listOperationPackages,
  component: RouteComponent,
});

function RouteComponent() {
  const packages = Route.useLoaderData();

  const sidebar = useItOperationCorePackageSidebar({ packages });

  return (
    <HStack className="h-full overflow-y-hidden">
      <Suspense fallback={<Loader size="size-6" />}>
        <Sidebar {...sidebar} />
      </Suspense>
      <HStack className="flex-1 p-6 overflow-x-auto">
        <Card
          className={cn(
            "w-full rounded-md",
            "outline-neutral-muted-border outline-solid outline-1",
          )}
        >
          <Outlet />
        </Card>
      </HStack>
    </HStack>
  );
}
